import { M as v } from "../MessageBoxEx-CteyjAsC.js";
import { u as O, a as D } from "../MessageBoxEx-CteyjAsC.js";
import t from "jquery";
import { U as w, k as f, j as r } from "../NaturalCompare-BhqAyIXe.js";
import { ref as p, createApp as x, nextTick as C } from "vue";
function I() {
  let m = !1;
  function g(n) {
    if (n.target instanceof Element && n.target.classList.contains("modal")) {
      var o = 1040 + 10 * t(".modal:visible").length;
      t(n.target).css({
        zIndex: o
      }), setTimeout(() => {
        t(".modal-backdrop").not(".modal-stack").css("z-index", o - 1).addClass("modal-stack");
      }, 0);
    }
  }
  function h(n) {
    if (n.target instanceof Element && n.target.classList.contains("modal")) {
      var o = 1040 + 10 * t(".modal:visible").length;
      t(".modal-backdrop.modal-stack").each(function() {
        t(this).css("z-index") == (o - 1).toString() && t(this).removeClass("modal-stack");
      });
    }
  }
  function e(n) {
    if (n.target instanceof Element && n.target.classList.contains("modal")) {
      var o = t(".modal:visible").length;
      o >= 1 && t("body").addClass("modal-open");
    }
  }
  m || (m = !0, document.addEventListener("show.bs.modal", g), document.addEventListener("hidden.bs.modal", h), document.addEventListener("hidden.bs.modal", e));
}
function b() {
  async function m(e) {
    return new Promise((n) => {
      const o = `mpMessageBoxEx${w.NewID()}`;
      let s = t(o);
      s.length === 0 && (s = t(`<div id="${o}"></div>`), t(document.body).append(s));
      const a = p(!0), i = (d) => {
        n(d), C(() => {
          c.unmount(), s.remove();
        });
      }, c = x(v, {
        show: a.value,
        flags: e.flags ? e.flags : f.MB_ICONINFORMATION | f.MB_OK,
        message: e.message,
        caption: e.caption,
        uniqueButtonCaptions: e.uniqueButtonCaptions,
        "onUpdate:show": (d) => a.value = d,
        onClose: i
      }), l = () => {
        a.value = !1, window.removeEventListener("popstate", l), i(r.IDCANCEL);
      };
      window.addEventListener("popstate", l), c.provide("$show", a), c.mount(`#${o}`);
    });
  }
  async function g(e) {
    return new Promise((n) => {
      const o = `mpMessageBoxEx${w.NewID()}`;
      let s = t(o);
      s.length === 0 && (s = t(`<div id="${o}"></div>`), t(document.body).append(s));
      const a = p(!0), i = p(e.checkStatus === void 0 ? !1 : e.checkStatus), c = (u) => {
        n({ buttonId: u, checkStatus: i.value }), C(() => {
          l.unmount(), s.remove();
        });
      }, l = x(v, {
        show: a.value,
        flags: e.flags ? e.flags : f.MB_ICONINFORMATION | f.MB_OK,
        message: e.message,
        caption: e.caption,
        uniqueButtonCaptions: e.uniqueButtonCaptions,
        useCheck: !0,
        checkText: e.checkText,
        checkStatus: i.value,
        "onUpdate:show": (u) => a.value = u,
        "onUpdate:check": (u) => i.value = u,
        onClose: c
      }), d = () => {
        a.value = !1, window.removeEventListener("popstate", d), c(r.IDCANCEL);
      };
      window.addEventListener("popstate", d), l.provide("$show", a), l.mount(`#${o}`);
    });
  }
  function h(e) {
    switch (e) {
      case r.IDABORT:
      case r.IDCANCEL:
      case r.IDNO:
        return !0;
      default:
        return !1;
    }
  }
  return {
    showMessageBox: m,
    showMessageBoxWithCheck: g,
    isButtonNegative: h
  };
}
export {
  O as useElementVisibility,
  b as useMessageBox,
  D as useModal,
  I as useModalOnModal
};
